<h1 mat-dialog-title class="d-flex align-items-center justify-content-between">
    <span>Add {{ data.title === 'ServiceLines' ? 'Service Line' : data.title }}</span>
    <i class="fa fa-times cursor-pointer" (click)="closeDialog()"></i>
</h1>
<div class="mt-4 pt-2 max-width-container">
    <div *ngIf="data.title=='ServiceLines'|| data.title=='SubCompetency'|| data.title=='Tech Stack Name' || data.title=='Service Offering'"
        class="mb-2 d-flex  gap-15">
        <label class="fs-12 black-clr">Competency<sup class="error">*</sup></label>

        <!-- <div class="w-100">
            <mat-select [class.is-invalid]="isCompetencySelected" (selectionChange)="updateServieLine($event)" [(ngModel)]="selectedServiceLine"
            placeholder="Select Competency">
            <mat-option *ngFor="let service of data.data" [value]="service.id">{{service.name}}</mat-option>
        </mat-select>
    </div> -->
        <div class="w-100">
            <mat-form-field class="custom_select" [class.is-invalid]="isCompetencySelected">
                <mat-select (selectionChange)="updateServieLine($event)" [(ngModel)]="selectedServiceLine"
                    placeholder="Select Competency" tabindex="-1">
                    <mat-option *ngFor="let service of data.data" [value]="service.id">{{service.name}}</mat-option>
                </mat-select>
            </mat-form-field>
            <p class="error" *ngIf="isCompetencySelected">Select the Competency</p>
        </div>
    </div>

    <div *ngIf=" data.title=='Service Offering'" class="mb-2 d-flex gap-15">
        <label class="fs-12 black-clr"> Service Line<sup class="error">*</sup></label>
        <!-- <mat-select (selectionChange)="disableError($event)" class="w-100 form-control"
                [(ngModel)]="selectedSubServiceLine" placeholder="Select Service Line">
                <mat-option *ngFor="let service of ServiceLines" [value]="service">{{service}}</mat-option>
            </mat-select> -->
        <div class="w-100">
            <mat-form-field class="custom_select" [class.is-invalid]="isServiceLineSelected">
                <mat-select (selectionChange)="disableError($event)" [(ngModel)]="selectedSubServiceLine"
                    placeholder="Select Service Line" tabindex="-1">
                    <mat-option *ngFor="let service of ServiceLines" [value]="service">{{service}}</mat-option>
                </mat-select>
            </mat-form-field>
            <p class="error" *ngIf="isServiceLineSelected">Select the Service Line</p>
        </div>
    </div>
    <div *ngIf=" data.title=='Tech Stack Name'" class="mb-2 mt-4 d-flex gap-15">
        <label class="fs-12 black-clr">{{data.subCompetencyName }}</label>
        <!-- <div class="w-100">
            <mat-select (selectionChange)="updateServieLine(currentComp.value)" [(ngModel)]="selectedSubServiceLine"
                placeholder="Select {{data.subCompetencyName}}">
                <mat-option *ngFor="let service of data.subCompetencyValues"
                    [value]="service.id">{{service.name}}</mat-option>
            </mat-select> -->


        <mat-form-field class="custom_select w-100">
            <mat-select (selectionChange)="updateServieLine($event)" [(ngModel)]="selectedSubServiceLine"
                placeholder="Select {{data.subCompetencyName}}" tabindex="-1">
                <mat-option *ngFor="let service of data.subCompetencyValues"
                    [value]="service.id">{{service.name}}</mat-option>
            </mat-select>
        </mat-form-field>
        <!-- </div> -->
    </div>

    <div class="d-flex gap-15">
        <label class="fs-12 black-clr">{{data.title === 'ServiceLines' ? 'Service Line' : data.title }}<sup
                class="error">*</sup></label>
        <div class="w-100">
            <input [(ngModel)]="field" (keyup)="checkInput(field)" class="form-control"
                [class.is-invalid]="isNotValidField"
                placeholder="Enter {{data.title === 'ServiceLines' ? 'Service Line' : data.title }}" tabindex="-1">
            <p class="error" *ngIf="isNotValidField">Please enter the valid {{data.title === 'ServiceLines' ?
                'Service Line'
                : data.title }}</p>
        </div>
    </div>

    <div *ngIf=" data.title=='Domain Name'" class="mb-2 d-flex gap-15">
        <label class="fs-12 black-clr">{{data.description }}</label>
        <div class="w-100">
            <textarea [(ngModel)]="description" (keyup)="checkTextAreaInput(description)"
                class="form-control description fs-14 black-clr" placeholder="Enter {{data.description}}" tabindex="-1"></textarea>
            <p class="error" *ngIf="isNotValidDescription">Please enter the valid {{data.description}}</p>
        </div>
    </div>

</div>

<div mat-dialog-actions class="dialog-footer d-flex align-items-center justify-content-end mt-4">
    
        <button (click)="closeDialog()" class="btn custom_btn inverted_btn_base mr-2" tabindex="-1">Cancel</button>
        <button (click)="addServiceLine()"
            [disabled]="((data.title=='SubServiceLine'|| data.title=='SubCompetency'||data.title=='Tech Stack Name') && !selectedServiceLine && !selectedSubServiceLine )"
            class="btn custom_btn primary_btn_base mr-2" tabindex="-1">Add</button>
    </div>